import { render } from "./App.vue?vue&type=template&id=02d6a264"
const script = {}

import "./App.vue?vue&type=style&index=0&id=02d6a264&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\demo\\three-3d-earth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__